import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { List, ListItem } from "@mui/material";
import "../../assets/css/footer.css";
import NavBarLandingPage from "./NavBarLandingPage";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";
import FooterLandingpage from "./FooterLandingpage";
function Privacy() {
  const stylesMain = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: "45px",
      letterSpacing: "0em",
      textAlign: "left",
     
    },
  };
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "1.75rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.5rem",
        lineHeight: "48px",
        // marginTop: "30px",
      },
    },
  };
  const headings = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.2rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.5rem",
        lineHeight: "48px",
        // marginTop: "30px",
      },
    },
  };
  const description = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: 18,
      fontWeight: 400,
      lineHeight: "28px",
      letterSpacing: "0em",
      textAlign: "left",
      width: "100%",
      height: "auto",
      "@media (max-width: 600px)": {
        fontSize: "1.2rem", // Adjust the font size for smaller screens
        lineHeight: "26px", // Adjust other styles as needed
      },
    },
  };
  return (
    <div>
      <NavBarLandingPage />
      <div className="privacy-background landing-page">
        <Box
          sx={{
            backgroundColor: "#1E53E8",
            borderRadius: "30px",
            padding: "3.1rem",
            margin: "40px",
            position: "relative",
            "@media (max-width: 1024px)": {
              padding: "30px",
              margin: "32px",          
            },
            "@media (max-width: 600px)": {
              padding: "1.5rem",
              margin: "0px",
              borderRadius: "22px",
              
            },
          }}
        >
          <Typography
            sx={{
              ...stylesMain.typography,
              color: "#fff",
              textTransform: "uppercase",
              // marginTop: "50px",
              height: "50px",
              "@media (max-width: 1024px)": {
                // marginTop: "15px",
                fontSize:"3.125rem",
            },
            "@media (max-width: 600px)": {
              fontSize: "2.5rem",
              lineHeight: "70px",
            },
            }}
          >
            PRIVACY POLICY
          </Typography>
          <Typography
            sx={{
              color: "#FFFFFF",
              marginTop: "0px",
              fontFamily: "Roboto Flex",
              fontSize: "1.1rem",
              lineHeight: "28px",
              fontWeight: 500,
            
              "@media (max-width: 600px)": {
                marginTop: "8px",
              },
            }}
          >
            Effective January 25,2024
          </Typography>

          <Typography
            sx={{
              ...styles.typography,
              color: "#FFFFFF",
              marginTop: "30px",
              fontFamily:"Roboto Flex",
              "@media (max-width: 1024px)": {
                marginTop: "30px",
                lineHeight: "30px",
            },
              "@media (max-width: 600px)": {
                fontSize: "1.4rem",
                lineHeight: "35px",
              },
            }}
          >
            Welcome to MegaConnect Technologies
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#FFFFFF",
              marginTop: "12px",
            }}
          >
            This Privacy Policy explains how we collect, use, and disclose your
            personal information when you use our website, Cloud PC service, and
            other related services.
          </Typography>
          <img
            src={TermsConditionVector}
            alt=""
            style={{ position: "absolute", right: "0", bottom: "0" }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: "30px",
            backgroundColor: " #F1F1F1",
            padding: "3.7rem",
            marginTop: "2rem",
            marginBlockEnd: "6rem",
            margin: "40px",
            "@media (max-width: 1024px)": {
              padding: "30px",
              margin: "32px",
          
            },
            "@media (max-width: 600px)": {
              padding: "1.8rem",
              margin: "0px",
              borderRadius: "22px",
               marginTop:"20px"
            },
          }}
        >
          <Typography
            sx={{ ...headings.typography, color: "#1E53E8", 
              // marginTop: "40px" 
            }}
          >
            Information we collect
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              padding: "10px 5px",
            }}
          >
            We may collect the following information.
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginTop: "12px" }}>Name and job title.</li>
              <li style={{ marginTop: "6px" }}>
                Contact information including email address.
              </li>

              <li style={{ marginTop: "6px" }}>
                Demographic information such as postcode, preferences, and
                interests.
              </li>

              <li style={{ marginTop: "6px" }}>
                Other information relevant to customer surveys and/or offers.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...headings.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            What we do with the information we gather
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              padding: "10px 5px",
            }}
          >
            We require this information to understand your needs and provide you
            With a better service, and in particular for the following reasons.
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginTop: "12px" }}>Internal record keeping.</li>
              <li style={{ marginTop: "6px" }}>
                We may use the information to improve our products and services.
              </li>

              <li style={{ marginTop: "6px" }}>
                We may periodically send promotional emails about new products,
                special offers or other information which we think you may find
                interesting using the email address Which you have provided,
              </li>

              <li style={{ marginTop: "6px" }}>
                From time to time, we may also use your information to contact
                you for market research purposes. We may contact you by email,
                phone, fax or mail, We may use the information to customize the
                website according to your interests.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
              padding: "10px 5px",
            }}
          >
            We are committed to ensuring that your information is secure. In
            order to prevent unauthorized access or disclosure we have put in
            suitable measures.
          </Typography>
          <Typography
            sx={{ ...headings.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Use of Cookies
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginBottom: "10px" }}>
                A cookie is a small file which asks permission to be placed on
                your computer's hard drive. Once you agree, the file is added
                and the cookie helps analyses web traffic or lets you know when
                you visit a particular site. Cookies allow web applications to
                respond to you as an individual. The web application can tailor
                its operations to your needs, likes and dislikes by gathering
                and remembering information about your preferences.
              </li>

              <li style={{ marginTop: "18px" }}>
                We use traffic log cookies to identify which pages are being
                used. This helps us analyses data about web page traffic and
                improve our website in order to tailor it to customer needs. We
                only use this information for statistical analysis purposes and
                then the data is removed from the system.
              </li>

              <li style={{ marginTop: "18px" }}>
                Overall, cookies help us provide you with a better website, by
                enabling us to monitor which pages you find useful and which you
                do not. A cookie in no way gives us access to your computer or
                any information about you, other than the data you choose to
                share with us.
              </li>

              <li style={{ marginTop: "18px" }}>
                You can choose to accept or decline cookies. Most web browsers
                automatically accept cookies, but you can usually modify your
                browser setting to decline cookies if you prefer. This may
                prevent you from taking full advantage of the website.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...headings.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Controlling Your Personal Information
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              marginTop: "16px",
            }}
          >
            You may choose to restrict the collection or use of your personal
            information in the following ways.
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginBottom: "10px" }}>
                Whenever you are asked to fill in a form on the website, look
                for the box that you can click to indicate that you do not want
                the information to be used by anybody for direct marketing
                purposes.
              </li>

              <li style={{ marginTop: "18px" }}>
                If you have previously agreed to us using your personal
                information for direct marketing purposes, you may change your
                mind at any time by writing to or emailing us at
                hr@techmega.cloud.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              marginTop: "16px",
            }}
          >
            We will not sell, distribute or lease your personal information to
            third parties unless we have your permission or are required by law
            to do so. We may use your personal information to send you
            promotional information about third parties which we think you may
            find interesting if you tell us that you wish this to happen.
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              marginTop: "16px",
            }}
          >
            If you believe that any information we are holding on you is
            incorrect or incomplete, please write to or email us as soon as
            possible, at the above address. We will promptly correct any
            information found to be incorrect.
          </Typography>
        </Box>
      </div>
      <FooterLandingpage />
    </div>
  );
}

export default Privacy;
